import React, { useState } from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import { Box, Typography } from "@material-ui/core";
import EditText from "../../components/EditText";
import Submit from "../../components/Submit";
import { useTranslation } from "react-i18next";
import SwipeableButton from "../../components/SwipeableButton";

const LoginForm = ({ onSubmit = () => {}, initialValues }) => {
  const { t } = useTranslation();
  const [disabledSubmit, setDisabledSubmit] = useState(true);

  const validationSchema = Yup.object().shape({
    username: Yup.string().required(t("login.errors.user_required")),
    password: Yup.string().required(t("login.errors.password_required")),
  });

  const onSwipeSuccess = (success) => {
    setDisabledSubmit(!success);
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {(props) => (
        <form onSubmit={props.handleSubmit}>
          <Box mb={3}>
            <Typography color="textPrimary" variant="h2">
              {t("login.title")}
            </Typography>
          </Box>
          <EditText {...props} label={t("login.username")} name="username" />
          <EditText
            {...props}
            label={t("login.password")}
            name="password"
            type="password"
          />
          <Box my={2} height={"50px"}>
            <SwipeableButton
              color="#6ab04c"
              onSuccess={onSwipeSuccess}
              text={t("login.swipe_text").toUpperCase()}
              text_unlocked={t("login.swipe_text_unlocked").toUpperCase()}
            />
          </Box>
          <Box my={2}>
            <Submit
              {...props}
              title={t("login.button")}
              isSubmitting={disabledSubmit}
            />
          </Box>
        </form>
      )}
    </Formik>
  );
};

export default LoginForm;
